import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si no sé nada de construcción?',
  a: 'Sí. El sistema fue diseñado para propietarios sin experiencia técnica. Cada paso tiene ilustraciones que muestran exactamente qué hacer. Las herramientas que necesitás son básicas: principalmente un taladro con percusión. Los materiales se consiguen en cualquier ferretería de barrio de Argentina.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Tras la compra recibís acceso inmediato para descargar los 4 módulos y los 3 bonos en PDF. Podés leerlos en el celular, la tablet o la computadora, e imprimirlos en casa para usarlos durante la obra.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. Todo el sistema está diseñado para ser imprimido. Las planillas, los checklists, el Diario de Obra de 21 Días y las tablas de materiales están optimizados para impresión en A4 en blanco y negro con cualquier impresora doméstica.'
}, {
  q: '¿Sirve si soy inquilino y no soy el dueño de la casa?',
  a: 'Para soluciones de superficie como sellar juntas de ventanas o pintura transpirable, sí podés aplicarlo. Para la inyección química que implica perforar paredes, necesitás autorización del propietario. El sistema incluye una guía para comunicarle al propietario el tratamiento y el impacto positivo en el valor de la propiedad.'
}, {
  q: '¿Tiene garantía real?',
  a: '30 días completos sin preguntas. Si en ese período sentís que el sistema no era lo que esperabas, te devolvemos el 100% de lo que pagaste. Sin formularios, sin explicaciones.'
}, {
  q: '¿Funciona para cualquier tipo de humedad?',
  a: 'El Módulo 1 te ayuda a identificar exactamente qué tipo de humedad tenés. El sistema cubre los tres tipos: ascendente, condensación y filtración. Si tenés un caso combinado, el Árbol de Decisión te dice exactamente qué atacar primero y en qué orden.'
}, {
  q: '¿Cuánto voy a gastar en materiales además del sistema?',
  a: 'Entre $35.000 y $65.000 ARS según el tamaño de tu problema y el tipo de ladrillo. La Calculadora Cero Desperdicio incluida en el Pasaporte del Maestro te dice exactamente cuánto comprar sin gastar de más. Las empresas profesionales cobran entre $450.000 y $1.200.000 ARS por el mismo trabajo.'
}];
export function FAQSection() {
  return <section className="py-8 md:py-10 px-4 bg-slate-950" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <FadeIn className="text-center mb-6" data-id="element-44">
          <HelpCircle className="w-8 h-8 text-orange-500 mx-auto mb-2" data-id="element-45" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-46">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-47">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-48">
              <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5 md:p-6" data-id="element-49">
                <h3 className="text-base md:text-lg font-bold text-white mb-2" data-id="element-50">
                  {faq.q}
                </h3>
                <p className="text-slate-400 leading-relaxed text-sm md:text-base" data-id="element-51">
                  {faq.a}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}